import { DOCUMENT } from '@angular/common';
import { Component, inject, Renderer2 } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { TokenService } from '@utilities/services/token.service';

@Component({
  selector: 'app-help-box',
  template: '',
})
export class HelpBoxComponent {
  private document = inject(DOCUMENT);
  private oktaAuth = inject(OKTA_AUTH);
  private renderer2 = inject(Renderer2);
  private tokenService = inject(TokenService);

  ngOnInit() {
    const id = this.tokenService.getToken() ?? this.oktaAuth.getAccessToken();

    (window as any).BOTMAKER_VAR = {
      PepsiCoCNVToken: id,
    };

    let script = this.renderer2.createElement('script');
    script.type = `text/javascript`;
    script.async = true;
    script.src = `https://go.botmaker.com/rest/webchat/p/KWD5OVJKY6/init.js`;

    this.renderer2.appendChild(this.document.body, script);
  }
}
